<template>
  <div class="home">
    <header class="header header1">
      <div class="header-menu">
        <div class="header-logo">
          <div class="header-logo-img">
            <a href="index.html">
              <img src="@/assets/img/home/foshologo2.png" />
              <!-- <img src="@/assets/img/info/05.png" /> -->
            </a>
          </div>
          <div class="header-logo-name">FOSHO</div>
        </div>
        <nav class="header-menu">
          <ul>
            <li class="active cursor"><span>首页</span></li>
            <li class="cursor" @click="goProgramme"><span>解决方案</span></li>
            <li class="cursor" @click="goSass"><span><span>SAAS</span>产品</span></li>
            <!-- <li class="cursor"><span>品牌服务</span></li>
            <li class="cursor"><span>营销学院</span></li>
            <li class="cursor"><span>关于我们</span></li> -->
          </ul>
        </nav>
        <div class="header-menu-list menu-list-1">
          <ul>
            <li @click="gosassmip"><span>FOSHO MIP</span></li>
            <!-- <li><span>经营沙盘</span></li>
            <li><span>洞察情报</span></li>
            <li><span>智能分销</span></li>
            <li><span>红人智选</span></li>
            <li><span>智能广告</span></li> -->
          </ul>
        </div>
        <div class="header-menu-list menu-list-2">
          <ul>
            <li><a href="#">品牌策略</a></li>
            <li><a href="#">品牌视觉</a></li>
            <li><a href="#">营销策略</a></li>
            <li><a href="#">联盟分销</a></li>
            <li><a href="#">红人营销</a></li>
            <li><a href="#">广告投放</a></li>
            <li><a href="#">v媒体合作</a></li>
          </ul>
        </div>
        <div class="header-menu-list menu-list-3">
          <ul>
            <li><a href="#">客户案例</a></li>
            <li><a href="#">出海案例</a></li>
          </ul>
        </div>
        <div class="header-menu-list menu-list-4">
          <ul>
            <li><a href="#">团队介绍</a></li>
            <li><a href="#">联系方式</a></li>
          </ul>
        </div>
      </div>
      <div class="header-login cursor">
        <div v-if="!usName" class="header-logo-name" @click="gologin">登录</div>
        <div v-if="usName" class="header-logo-name" @click="gopersonal">{{usName}}</div>
        <div class="header-login-icon">
          <img src="@/assets/img/home/login icon.png" />
        </div>
      </div>
    </header>
    <center>
      <div class="center-banner">
        <div class="center-banner-left">
          <div class="center-left-logo">
            <div class="center-logo-img">
              <img src="@/assets/img/home/logo.gif" />
            </div>
          </div>
          <p class="center-left-title">品牌出海，智能加速</p>
          <p class="center-left-title2">BRAND INTELLIGENCE,SHARED FUTURE</p>
          <p class="center-left-text">DTC品牌全球化ALL-IN-ONE营销智能解决方案</p>
        </div>
        <div class="center-banner-right">
          <img src="@/assets/img/home/consumer touch point.png" />
        </div>
      </div>
      <div class="center-hxys center">
        <div class="center-hxys-title">核心优势</div>
        <div class="center-hxys-icon">
          <div class="center-icon-pub">
            <div class="icon-pub-icon"><img src="@/assets/img/home/icon.png" /></div>
            <div class="icon-pub-title">全链路品牌智能驱动</div>
            <div class="icon-pub-English">Brand Intelligence</div>
            <div class="icon-pub-text">
              <span>品牌</span>全链路数据智能平台<br />以DTC品牌+独立站需求为核心<br />出海品牌专属智能营销应用
            </div>
          </div>
          <div class="center-icon-pub">
            <div class="icon-pub-icon"><img src="@/assets/img/home/icon3.png" /></div>
            <div class="icon-pub-title">全球多元合作生态</div>
            <div class="icon-pub-English">Advanced Network</div>
            <div class="icon-pub-text">
              <span>全方位</span>上下游产业协同数据生态<br />10万+全球&本地化核心营销资源<br />前后端运营战略合作伙伴
            </div>
          </div>
          <div class="center-icon-pub">
            <div class="icon-pub-icon"><img src="@/assets/img/home/icon6.png" /></div>
            <div class="icon-pub-title">品牌本地化成功经验</div>
            <div class="icon-pub-English">Native Brand Experience</div>
            <div class="icon-pub-text">
              <span>0-1</span>出海品牌本地化成功经验<br />数十亿规模出海独立站运营作战经验<br />10年+海外作战经验
            </div>
          </div>
          <div class="center-icon-pub">
            <div class="icon-pub-icon"><img src="@/assets/img/home/icon9.png" /></div>
            <div class="icon-pub-title">专注营销增长SAAS工具</div>
            <div class="icon-pub-English">Business-Driven SAAS</div>
            <div class="icon-pub-text">
              <span>自动化</span>、低门槛、易操作<br />系统化、专业化的营销管理<br />从业务出发的数字化营销变革
            </div>
          </div>
        </div>
      </div>
      <div class="center-hzhb center">
        <div class="center-hxys-title">100000 +<br />核心资源网及全球合作伙伴</div>
        <p class="center-text"> 100+ 全球头部媒体、数据、IP合作关系；100,000+ 本地化红人、<br />营销分销渠道网络， 资源含括欧洲、北美、东南亚、中东非等地区</p>
      </div>
      <div class="center_hzpp center">
        <div class="center-hxys-title">合作品牌</div>
        <div class="center-hzpp-logo">
          <div class="center-logo-pub">
            <img src="@/assets/img/home/333.png" />
          </div>
          <div class="center-logo-pub">
            <img src="@/assets/img/home/111-1.png" />
          </div>
          <div class="center-logo-pub">
            <img src="@/assets/img/home/444.png" />
          </div>
          <div class="center-logo-pub">
            <img src="@/assets/img/home/aaaa-3.png" />
          </div>
        </div>
      </div>

      <div class="center center-Em">
        <div class="center-Em-titleE">Get In Touch</div>
        <div class="center-Em-title">SEND MESSAGE</div>
        <div class="center-Em-text">与我们取得联系</div>
        <div class="el_fkls">
          <el-form class="center-from" :inline="true" :model="form" ref="form1" :rules="rules1">
            <div style="width:100%">
              <div class="form_input">
                <el-form-item style="width:100%;height:100%;" label="" prop="firstName">
                  <el-input style="width:100%;height:100%;" v-model="form.firstName" type="text" placeholder="姓"></el-input>
                </el-form-item>
              </div>
              <div class="form_input_t">
                <el-form-item style="width:100%;height:100%;" label="" prop="lastName">
                  <el-input style="width:100%;height:100%;" v-model="form.lastName" type="text" placeholder="名"></el-input>
                </el-form-item>
              </div>
            </div>
            <div style="width:100%">
              <div class="form_input">
                <el-form-item style="width:100%;height:100%;" label="" prop="companyEmail">
                  <el-input style="width:100%;height:100%;" v-model="form.companyEmail" type="text" placeholder="邮箱"></el-input>
                </el-form-item>
              </div>
              <div class="form_input_t">
                <el-form-item style="width:100%;height:100%;" label="" prop="companyName">
                  <el-input style="width:100%;height:100%;" v-model="form.companyName" type="text" placeholder="公司名称"></el-input>
                </el-form-item>
              </div>
            </div>
            <div style="width:100%">
              <el-form-item style="width:80%;height:100%;" label="" prop="subjectCode">
                <el-select style="width:80%" clearable v-model="form.subjectCode" placeholder="主题" @change="readnclik">
                  <el-option v-for="item in themeList" :key="item.code" :label="item.value" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <el-form-item style="width:100%;" label="" prop="descriptionText">
              <el-input style="width:100%;" :rows="4" v-model="form.descriptionText" type="textarea" placeholder="留言"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="center-from-btn">
          <button @click="addSubmit('form1')">发送</button>
        </div>
      </div>
    </center>
    <footer>
      <div class="footer-body">
        <div class="footer-body-center">
          <div class="footer-center-pub">
            <div class="footer-pub-logo">
              <img src="@/assets/img/home/aaaalobo.png" />
            </div>
          </div>
          <ul class="footer-menu">
            <li>首页</li>
            <li>解决方案</li>
            <li>SAAS产品</li>
            <li>品牌服务</li>
            <li>音效学院</li>
            <li>关于我们</li>
            <li>隐私条款</li>
          </ul>
          <div class="footer-center-pub">
            <ul>
              <li>
                邮箱：business@foshobrands.com
              </li>
              <li>
                <div class="footer-pub-right">
                  <p>订阅我们</p>
                  <div class="footer-right-get">
                    <div class="get-icon">
                      <img src="@/assets/img/home/yz.png" />
                    </div>
                    <input class="get-input" style="color:#fff;" v-model="account" type="email" name="your-email" value="" placeholder="输入您的邮箱">
                  </div>
                </div>
              </li>
              <li>
                <button class="footer-get-send cursor" @click="subscribe">发送</button>
              </li>
            </ul>
          </div>
          <div class="footer-pub-right2">
            <div class="ewm"><img src="@/assets/img/home/ewm.jpg" /></div>
            <p>官方微信</p>
          </div>
        </div>
      </div>
    </footer>
    <div class="tips_cookie" v-if="acceptStuts != 1">
      <div class="tips_p">
        <div class="tips_close">×</div>
        我们正使用 cookie 来改善您的访问体验。 FOSHO非常重视您的个人隐私，当您访问我们的网站<br /> www.foshobrands.com时，请同意使用所有cookie 。<br />
        <br /> 如果您想详细了解我们如何使用 cookie 请访问我们的 《隐私政策》。
        <br />
        <button class="tips_yes cursor" @click="accept">接受 <img src="@/assets/img/home/yes.png" /></button>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery"
import { ACCEPTCOOKIES, SUBSCRIBE, SELECTSUBJECTS, CONCACT, QUERY } from '../api/home'
export default {
  name: "home",
  data() {
    let email = (rule, value, callback) => {
      // 邮箱正则校验
      if (!value) {
        return callback(new Error("邮箱不能为空"));
      } else {
        if (
          !/^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/.test(
            value
          )
        ) {
          callback(new Error("请输入正确邮箱地址"));
        } else {
          callback();
        }
      }
    };
    return {
      name: "",
      acceptStuts: '',
      account: '',
      themeList: [],
      form: {
        subjectCode: '',
        firstName: '',
        lastName: '',
        companyEmail: '',
        companyName: '',
        descriptionText: '',
      },
      rules1: {
        firstName: [{ required: true, message: "姓不能为空", trigger: ["blur", "change"], },],
        lastName: [{ required: true, message: "名不能为空", trigger: ["blur", "change"], },],
        companyEmail: [{ required: true, message: "邮箱不能为空", trigger: ["blur", "change"], }, { validator: email, trigger: ["blur", "change"] },],
        companyName: [{ required: true, message: "公司名字不能为空", trigger: ["blur", "change"], },],
        descriptionText: [{ required: true, message: "留言不能为空", trigger: ["blur", "change"], },],
        subjectCode: [{ required: true, message: "主题不能为空", trigger: ["blur", "change"], },],
      },
      usName: ''
    };
  },
  mounted() {
    this.selectsubjects()
    this.acceptStuts = localStorage.getItem('cooks')
    $(".header-menu ul li").mousemove(function () {
      var activeVal = $(this).text();
      if (activeVal === 'SAAS产品') {
        $(".menu-list-2,.menu-list-3,.menu-list-4").css("display", "none");
        $(".menu-list-1").css("display", "block");
      }
      if (activeVal === '品牌服务') {
        $(".menu-list-1,.menu-list-3,.menu-list-4").css("display", "none");
        $(".menu-list-2").css("display", "block");
      }
      if (activeVal === '营销学院') {
        $(".menu-list-2,.menu-list-1,.menu-list-4").css("display", "none");
        $(".menu-list-3").css("display", "block");
      }
      if (activeVal === '关于我们') {
        $(".menu-list-2,.menu-list-3,.menu-list-1").css("display", "none");
        $(".menu-list-4").css("display", "block");
      }
    });
    $('center, footer').click(function () {
      $(".menu-list-1,.menu-list-2,.menu-list-3,.menu-list-4").css("display", "none")
    })
    //cookie告知点击关闭
    $(".tips_close").click(function () {
      $(".tips_cookie").css("display", "none");
    })
    //cookie告知点击接受
    $(".tips_yes").click(function () {
      $(".tips_cookie").css("display", "none");
    })
    this.$store.state.name = "李四";
    // this.myEcharts()
    // this.queryInfo()
  },
  methods: {
    /**
  * queryInfo()
  * 获取登录信息
  */
    queryInfo() {
      QUERY().then(res => {
        if (res.data.code == 'nolog') {
          // this.$router.push('login')
        } else {
          this.usName = res.data.body.name
          localStorage.setItem("name", res.data.body.name);
        }
      })
    },
    // 官网-接受cookies隐私协议
    accept() {
      ACCEPTCOOKIES().then(res => {
        if (res.data.code == 'error') {
          this.$message.error(res.data.msg)
        } else {
          this.acceptStuts = 1
          localStorage.setItem('cooks', this.acceptStuts)
        }
      })
    },
    // 订阅
    subscribe() {
      SUBSCRIBE({ account: this.account }).then(res => {
        if (res.data.code == 'error') {
          this.$message.error(res.data.msg)
        } else {
          this.$message({
            message: '订阅成功',
            type: 'success'
          });
          this.account = ''
        }
      })
    },
    // 主题
    selectsubjects() {
      SELECTSUBJECTS().then(res => {
        this.themeList = res.data.body
      })
    },
    // 选择主题
    readnclik(e) {
      this.form.subjectCode = e
    },
    // 联系我们-数据新增
    addSubmit() {
      let rules1 = new Promise((resolve, reject) => {
        this.$refs["form1"].validate((valid) => {
          if (valid) {
            resolve();
          }
        });
      });
      Promise.all([rules1]).then(() => {
        this.saveChannel();
      });
    },
    saveChannel() {
      CONCACT(this.form).then(res => {
        if (res.data.code == 'error') {
          this.$message.error(res.data.msg)
        } else {
          this.$message({
            message: '发送成功',
            type: 'success'
          });
        }
      })
    },
    gologin() {
      this.$router.push("./login");
    },
    gopersonal() {
      this.$router.push("./personal");
    },
    goProgramme() {
      this.$router.push("./programme");
    },
    goSass() {
      this.$router.push("./sass");
    },
    infoman() {
      this.$router.push("./personal");
    },
    gosassmip() {
      this.$router.push("./sassmip");
    }
    // myEcharts(){
    //    let myChart3 = this.$echarts.init(document.getElementById("myChart3"));
    //    var option = {
    //     title: {
    //       text: 'echarts入门示例',
    //     },
    //     tooltip: {},
    //     legend: {
    //       data: ['销量']
    //     },
    //     xAxis: {
    //       data: ['衬衫','羊毛衫','雪纺衫','裤子','高跟鞋','袜子']
    //     },
    //     yAxis: {},
    //     series: [{
    //       name: '销量',
    //       type: 'bar',
    //       data: [5,20,36,10,10,20]
    //     }]
    //   };
    //   myChart3.setOption(option);

    // }
  },
};
</script>
<style lang="less" scoped>
.el_fkls {
  width: 100%;
  text-align: left;
  .form_input {
    width: 45%;
    // display: inline-block;
    float: left;
  }
  .form_input_t {
    width: 45%;
    float: right;
  }
}
</style>
<style lang="less">
.home {
  .el-input__inner {
    // border: none;
    border: 2px solid #333333;
    height: 50px;
    border-radius: 5px;
    background: rgb(250, 250, 253);
    // margin-top: 10px;
  }
  .el-textarea__inner {
    border: 2px solid #333333;
    // height: 50px;
    border-radius: 5px;
    background: rgb(250, 250, 253);
  }
   
}
</style>
